import SexoService from "@/api/services/personal/nomencladores/SexoService"
import Vue from "vue"

const state = () => ({
    sexos: [],
    pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 10,
        sortBy: "nombre",
        rowsPerPageItems: [5, 10, 20, 30, 40, 50]
    }
})

const getters = {
    SEXOS: state => {
        return state.sexos
    },
    SEXOS_PAG: state => {
        return state.pagination
    }
}

const mutations = {
    SET_SEXOS: (state, payload) => {
        state.sexos = payload
    },

    SET_SEXOS_PAG: (state, payload) => {
        state.pagination = payload
    },

    ADD_SEXO: (state, payload) => {
        state.sexos.push(payload)
    },

    UPDATE_SEXO: (state, payload) => {
        state.sexos = state.sexos.map(el => (el.id === payload.id ? payload : el))
    },

    DELETE_SEXO: (state, payload) => {
        state.sexos = state.sexos.filter(el => el.id !== payload.id)
    }
}

const actions = {
    LOAD_SEXOS: async ({ commit, state }, { filter, sexoEstado }) => {
        try {
            let pagination = {
                page: state.pagination.page,
                rowsPerPage: state.pagination.rowsPerPage,
                sortBy: state.pagination.descending ? "-" + state.pagination.sortBy : state.pagination.sortBy
            }
            let { data, status, headers } = await SexoService.get({ filter, sexoEstado, ...pagination })
            if (status === 200) {
                commit("SET_SEXOS", data)
                return parseInt(headers["x-pagination-total-count"])
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los sexos, inténtelo nuevamente"
            })
        }
    },

    LOAD_ALL_SEXOS: async ({ commit }) => {
        try {
            let { data, status } = await SexoService.getAll()
            if (status === 200) {
                commit("SET_SEXOS", data)
                return data
            }
        } catch (error) {
            if (error.response) {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    LOAD_ALL_RECORDS_SEXOS: async ({ commit }) => {
        try {
            let { data, status } = await SexoService.getAllRecords()
            if (status === 200) {
                commit("SET_SEXOS", data)
                return null
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se han podido cargar los sexos, inténtelo nuevamente"
            })
        }
    },

    LOAD_HISTORY_SEXO: async ({ commit }, payload) => {
        try {
            let { data, status } = await SexoService.getHistory(payload)
            if (status === 200) {
                commit("UPDATE_SEXO", data)
            }
            return null
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido cargar el historial del sexo, inténtelo nuevamente"
            })
        }
    },

    ADD_SEXO: async ({ commit }, payload) => {
        try {
            let { data, status } = await SexoService.post(payload)
            if (status === 201) {
                commit("ADD_SEXO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Agregando",
                    text: "El sexo ha sido agregado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido agregar el sexo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    UPDATE_SEXO: async ({ commit }, payload) => {
        try {
            let { data, status } = await SexoService.put(payload)
            if (status === 200) {
                commit("UPDATE_SEXO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Modificando",
                    text: "El sexo ha sido modificado satisfactoriamente"
                })
            }
            return null
        } catch (error) {
            if (!error.response) {
                Vue.notify({
                    group: "pages",
                    type: "error",
                    title: "Servidor",
                    text: "No se ha podido modificar el sexo, inténtelo nuevamente"
                })
            } else {
                return { data: error.response.data, status: error.response.status }
            }
        }
    },

    DELETE_SEXO: async ({ commit }, payload) => {
        try {
            let { status, data } = await SexoService.delete(payload)
            if (status === 204) {
                commit("DELETE_SEXO", payload)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Eliminando",
                    text: "El sexo ha sido eliminado satisfactoriamente"
                })
            }
            if (status === 200) {
                commit("UPDATE_SEXO", data)
                Vue.notify({
                    group: "pages",
                    type: "success",
                    title: "Deshabilitando",
                    text: "El sexo ha sido deshabilitado satisfactoriamente"
                })
            }
        } catch (error) {
            Vue.notify({
                group: "pages",
                type: "error",
                title: "Servidor",
                text: "No se ha podido eliminar/deshalitar el sexo, inténtelo nuevamente"
            })
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}
